import { Base } from "ui/Scripts/source/framework/base";
import { ApiError, IApiError } from "ui/Scripts/source/models/common/apiError";
import { Session } from "../session/session";
import downloadjs from "downloadjs";

export interface IApiSaveSuccess {
    id: string;
    message: string;
}

export class ApiSaveSuccess implements IApiSaveSuccess {
    id: string;
    message: string;

    constructor();
    constructor(obj: IApiSaveSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.message = obj && obj.message || "";
    }
}

export function isInstanceOfIApiError(object: any): object is IApiError {
    return object && "status" in object && "message" in object && typeof(object.status) === "number" && typeof(object.message) === "string";
}

export function getErrorMessageFromError(error: any): string {
    if (isInstanceOfIApiError(error)) {
        return error.message;
    } else {
        return error;
    }
}

export function authorizationHeaderValue() {
    const accessToken = Session.getAccessToken();
    if (!Base.isNullOrEmpty(accessToken)) {
        return "Bearer " + accessToken;
    } else {
        return "";
    }
}

export function authorizationHeaderRefreshTokenValue() {
    const refreshToken = Session.getRefreshToken();
    if (!Base.isNullOrEmpty(refreshToken)) {
        return "Bearer " + refreshToken;
    } else {
        return "";
    }
}

function getErrorMessageFromBody(text: string): string {
    if (Base.isJsonString(text)) {
        const obj = JSON.parse(text);
        const message = !Base.isNullOrEmpty(obj.message) ? obj.message : (!Base.isNullOrEmpty(obj.Message) ? obj.Message : text);
        return message;
    } else {
        return text;
    }
}

export function getJsonHeaders() {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json;charset=utf-8",
        "Authorization": authorizationHeaderValue(),
        "DeviceId": Session.getDeviceId()
    };
}

export function getJsonHeadersPublic() {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json;charset=utf-8",
        "DeviceId": Session.getDeviceId()
    };
}

export function getFormDataHeaders() {
    return {
        "Accept": "application/json",
        "Authorization": authorizationHeaderValue(),
        "DeviceId": Session.getDeviceId()
    };
}

export function appIsUpdated(error): boolean {
    if (!error) return false;
    const message: string = Base.isString(error)
        ? error
        : (Base.isString(error.message)
            ? error.message
            : "");
    if (message && message.indexOf('data-update-page="app_offline.htm"') > -1) {
        let href = window.location.href;
        if (window.location.href.indexOf("ts=") > -1) {
            href = window.location.href.replace(/ts=[^&]*/, "ts=" + Base.getTimeStamp());
        } else {
            const separator = window.location.href.indexOf("?") > -1 ? "&" : "?";
            href = window.location.href + separator + "ts=" + Base.getTimeStamp();
        }
        window.location.href = href;
        return true;
    }
    return false;
}

export function handleResponse(response: Response): any {
    console.log(response);
    return new Promise((resolve, reject) => {
        if (response.ok) {
            // return json if it was returned in the response
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                resolve(null);
            }
        } else {
            // return error message
            const error = new ApiError();
            error.status = response.status;
            response.text().then(text => {
                if (appIsUpdated(text)) {
                    return null;
                }
                error.message = getErrorMessageFromBody(text);
                reject(error);
            });
        }
    });
}

export function handleFileResponse(response: Response): any {
    console.log(response);
    let filename: string = "";
    return new Promise((resolve, reject) => {
        if (response.ok) {
            filename = response.headers.get("content-disposition") ?? "";
            console.log(filename);
            if (filename && filename.indexOf("attachment") !== -1) {
                const filenameRegex = /filename\*[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/ig;
                const matches = filenameRegex.exec(filename);
                if (matches != null && matches.length > 3 && matches[3]) {
                    filename = matches[3].replace(/['"]/g, "");
                    filename = decodeURIComponent(filename);
                }
            }
            return resolve(response.blob());
        } else {
            // return error message
            const error = new ApiError();
            error.status = response.status;
            response.text().then(text => {
                if (appIsUpdated(text)) {
                    return null;
                }
                error.message = getErrorMessageFromBody(text);
                reject(error);
            });
            return null;
        }
    }).then(body => {
        const index = filename.lastIndexOf(".");
        const suffix = " (" + Base.getTimeStamp(false) + ")";
        const newFileName = (index > -1
            ? filename.substr(0, index) + suffix + filename.substr(index)
            : filename + suffix).trim();
        downloadjs(body as Blob, newFileName, "application/octet-stream");
        //downloadjs(body as Blob, Base.getTimeStamp(false) + "_" + filename, "application/octet-stream");
        return new Promise((resolve) => {
            return resolve(filename);
        });
    });
}

export function handleError(error) {
    console.log(error);
    const isAborted = error && error.name === "AbortError";
    if (appIsUpdated(error)) {
        return;
    }
    return Promise.reject(isAborted ? null : error && error.message);
}